import { render, staticRenderFns } from "./WcLanguageSwitch.vue?vue&type=template&id=f1d3cc22&lang=pug&"
import script from "./WcLanguageSwitch.vue?vue&type=script&lang=js&"
export * from "./WcLanguageSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports